import "./Columbia04.css";
import img1 from "./../../../img/bg/bg-columbia.webp";

import location from "./../../../img/icons/location.png";
import phone from "./../../../img/icons/phone.png";

function Columbia04() {
  return (
    <div className="Columbia04 section">
      <div className="container">
        <div className="Columbia04-box">
          <div className="Columbia04-card">
            <p className="eyebrow green">WATERLOO | ONTARIO</p>
            <h2>Columbia Street</h2>
            <p>
              Easily accessible from the south end of the city, this location
              was opened to meet the growing demand for our master services. It
              offers the same great barbers and a welcoming environment.
            </p>

            <div className="divider"></div>

            <div className="Columbia04-card-list">
              <img src={location} alt="" />
              <p>450 Columbia St W, Waterloo, ON N2T 2W1, Canada</p>
            </div>

            <div className="Columbia04-card-list">
              <img src={phone} alt="" />
              <p>(519) 746-8764</p>
            </div>

            <a
              href="https://bookings.gettimely.com/razorkingbarbershopsalon/book"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-3"
            >
              BOOK NOW
            </a>
          </div>

          <img src={img1} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Columbia04;
